import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type MerchantsSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_MERCHANTS_SORT_OPTION: MerchantsSortOption = "newest";

const OPTIONS: SortOption<MerchantsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function merchantsSortOptionLabel(option: MerchantsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function merchantsSortOptionToParams(option: MerchantsSortOption): {
  sortBy: "createdAt" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortMerchantsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: MerchantsSortOption;
  setSortOption: (option: MerchantsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Merchants"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
